import { useTheme } from '@mui/material/styles';
import { navigate } from 'gatsby';
import React, { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import Icon from '@components/Icon/Icon';
import { CircleLoader } from '@components/Loaders';
import {
  HorizontalFlex,
  VerticalFlex,
} from '@components/RecordCard/RecordCard.style';
import { Time } from '@components/UpcomingAppointmentCard/UpcomingAppointmentCard.style';

import { ROUTINES } from '@constants/routes';

import useRoutines from '@hooks/useRoutines';
import { useSession } from '@hooks/useSession';

import type { RoutineEvent } from '@models/routine';

import { formatTime } from '@utils/format';

import { Check } from '@views/Dashboard/RoutineCard/RoutineCard.style';

const messages = defineMessages({
  notCompleted: {
    id: 'GLOBAL.notCompleted',
    defaultMessage: 'Not completed',
  },
  completed: {
    id: 'GLOBAL.completed',
    defaultMessage: 'Completed',
  },
});

function TodaysRoutine({
  routine,
  time,
}: {
  routine: RoutineEvent;
  time: Date;
}) {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();
  const [loading, setLoading] = useState(false);
  const { completeRoutine, isRoutineComplete } = useRoutines();
  const isComplete = isRoutineComplete(routine);
  const [user_id] = [activeProfile?.user_id];
  const { palette } = useTheme();

  async function onChangeStatus(routine: RoutineEvent) {
    if (!user_id) {
      return;
    }
    setLoading(true);
    await completeRoutine(routine);
    setLoading(false);
  }

  return (
    <div style={{ width: '100%' }}>
      <HorizontalFlex>
        <VerticalFlex
          alignItems="flex-start"
          onClick={() => {
            navigate(`${ROUTINES}${routine.id}`);
          }}
          style={{
            color: isComplete ? palette.success.main : palette.error.main,
            height: 44,
            width: '90%',
          }}
        >
          <Time>{formatTime(time)}</Time>
          <div>
            {formatMessage(
              isComplete ? messages.completed : messages.notCompleted
            )}
          </div>
        </VerticalFlex>
        <VerticalFlex alignItems="flex-end" paddingLeft={10}>
          <Check>
            <CircleLoader loading={loading} size="28px">
              <Icon
                clickable
                color={isComplete ? 'success.main' : 'text.secondary'}
                name={isComplete ? 'circle-check' : 'check'}
                onClick={() => {
                  onChangeStatus(routine);
                }}
                style={{
                  fontSize: isComplete ? 34 : 20,
                  paddingRight: isComplete ? 0 : 5,
                }}
              />
            </CircleLoader>
          </Check>
        </VerticalFlex>
      </HorizontalFlex>
    </div>
  );
}

export default TodaysRoutine;
